import React, { useState } from "react";
import AdresArama from "./AdresArama";
import KodSorgulama from "./KodSorgulama";
import AdaParselArama from "./AdaParselArama";

export default function SidebarForms() {
  const [selectedPage, setSelectedPage] = useState(0);

  const selectedTitleStyle = {
    backgroundColor: "rgb(35, 156, 213)",
  };

  let onClickTitle = (page) => {
    if (selectedPage == page) {
      setSelectedPage(0);
      return;
    }
    setSelectedPage(page);
  };

  return (
    <div style={{ padding: "3px" }}>
      <div className="col-12" style={{ marginTop: "10px" }}>
        <div id="aramaTitle" className="formTitleAlt" style={selectedPage === 1 ? selectedTitleStyle : null} onClick={() => onClickTitle(1)}>
          Adres Arama
        </div>
      </div>

      {selectedPage === 1 ? <AdresArama /> : null}

      <div className="col-12">
        <div className="formTitleAlt" style={selectedPage === 2 ? selectedTitleStyle : null} onClick={() => onClickTitle(2)}>
          Adres Kodu Doğrulama
        </div>
      </div>

      {selectedPage === 2 ? <KodSorgulama /> : null}

      <div className="col-12">
        <div className="formTitleAlt" style={selectedPage === 3 ? selectedTitleStyle : null} onClick={() => onClickTitle(3)}>
          Ada/Parsel Arama
        </div>
      </div>
      {selectedPage === 3 ? <AdaParselArama /> : null}
    </div>
  );
}
